import { NotificationType } from '../../../../../services/exports/Constants';

export default {
  title: 'Tiene {{length}} alertas',
  notifications: {
    titles: {
      [NotificationType.PaymentGatewayVerificationPending]: 'Información de pago en revisión',
      [NotificationType.PaymentGatewayVerificationSuccessful]: 'Información de pago verificada',
      [NotificationType.PaymentGatewayVerificationFailed]: 'Error en la información de pago',
    },
    descriptions: {
      [NotificationType.PaymentGatewayVerificationPending]:
        'Su información de pago está siendo revisada por Stripe. Esto puede tardar hasta 48 horas.',
      [NotificationType.PaymentGatewayVerificationSuccessful]:
        'Su información de pago se ha verificado correctamente. Ya puede recibir pagos.',
      [NotificationType.PaymentGatewayVerificationFailed]:
        'Parece que hubo un error con su información. Haga clic aquí para actualizarla.',
    },
  },
};
